import './projects.css';
export default function Projects() {
  return (
    <div className='projectswrapper' id='projects'>
      <h1 data-aos='fade-down'>projects</h1>
      <div className='projectwrapper' data-aos='fade-left'>
        <a href='https://github.com/m1ggy/switchboard' className='projectlink'>
          AI phone system
        </a>
        <p>fully fledged phone system on the web, powered by twilio!</p>
      </div>
      <div className='projectwrapper' data-aos='fade-right'>
        <a href='https://github.com/m1ggy/manga-reader' className='projectlink'>
          manga reader
        </a>
        <p>
         personal manga reader bcs f*ck ads, powered by consumet!
        </p>
      </div>
    </div>
  );
}
